import React, { useState, useEffect } from 'react';
import './PageLoader.css';

export default function PageLoader() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((p) => {
        if (p >= 100) { clearInterval(interval); return 100; }
        return p + Math.random() * 15 + 5;
      });
    }, 120);
    return () => clearInterval(interval);
  }, []);

  const value = Math.min(progress, 100);

  return (
    <div className="page-loader" role="status" aria-label="Chargement">
      <div className="pl-aurora" aria-hidden="true">
        <span className="pl-blob pl-blob-1" />
        <span className="pl-blob pl-blob-2" />
      </div>
      <div className="pl-grid" aria-hidden="true" />
      <div className="pl-grain" aria-hidden="true" />

      <div className="pl-content">
        <div className="pl-eyebrow">
          <span className="pl-eyebrow-line" />
          Chargement
        </div>

        <div className="pl-logo">
          <img src="/logo.png" alt="Nexia Digital" width="140" height="40" fetchpriority="high" />
        </div>

        <div className="pl-progress">
          <div className="pl-bar-wrap" role="progressbar" aria-valuenow={Math.round(value)} aria-valuemin={0} aria-valuemax={100}>
            <div className="pl-bar" style={{ width: `${value}%` }} />
          </div>
          <div className="pl-progress-meta">
            <span>{Math.round(value).toString().padStart(2, '0')}<em>%</em></span>
            <span className="pl-status">
              <span className="pl-dot" />
              Préparation
            </span>
          </div>
        </div>
      </div>

      <div className="pl-mark pl-mark-tl" aria-hidden="true">N°&nbsp;01</div>
      <div className="pl-mark pl-mark-br" aria-hidden="true">Nexia&nbsp;Digital</div>
    </div>
  );
}
